import React from "react";
import EnsaConstant from "./EnsaConstant";

const ChartKesenjanganGenderSk = ({ dataLiterasi }) => {
    require("./Ensa.css");
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20', width: '100%' }}>
            {dataLiterasi.map((item, i) =>
                <div key={i} style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '10px' }}>
                    <div style={{width: '20%', textAlign: 'center'}}>
                        <img src={item.key == 'SRONGLY RECOMMENDED' ? '/assets/image/done_all.svg' : item.key == 'RECOMMENDED' ? '/assets/image/verified.svg' : item.key == 'POORLY RECOMMENDED' ? '/assets/image/minimize.svg' : 'assets/image/minimize.svg'} width={"30px"} alt="" />
                    </div>
                    <div style={{width: '80%'}}>
                        <div className="title-tema">{item.key}</div>
                        {item.value.map((itemDesc, o) =>
                            <div key={o} className="desc-tema">{o+1}. {itemDesc}</div>
                        )}
                    </div>
                </div>
            )}
        </div>

    );
};

export default ChartKesenjanganGenderSk;
